module.exports = __webpack_public_path__ + "img/rugbyLes5.41f40874.jpg";